module.exports = __webpack_public_path__ + "media/images/emblems/Blason_suisse_commune_Chavannes-sur-Moudon-395060c51a356c4dbeef79103454d631.svg";